<div>
    <div class="actions">
      <button (click)="addvehicleInBlackList()" class="btn-action" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'BlackList'">
        <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
          Add Vehicle
      </button>
        <button (click)="bulkUploadInput.click()" class="btn-action" [disabled]="role === 'Member'"
                [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Bulk Upload'">
            <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
            Bulk Upload
        </button>
        <button
                type="button"
                class="btn-icon-action"
                (click)="downloadTemplate()"
                [disabled]="role === 'Member'"
                title="Download Blocklist Import Template">
            <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
        </button>
        <input #bulkUploadInput type="file" accept=".csv,.xlsx" (change)="uploadBulkFile($event)" hidden/>
    </div>

    <app-bulk-import-result
            *ngIf="bulkImportResult"
            [totalImported]="bulkImportResult.totalImported"
            [totalFailed]="bulkImportResult.totalFailed"
            [errors]="bulkImportResult.errors"
            [failedRowsCsvBase64]="bulkImportResult.failedRowsCsvBase64"
            [failedRowsFilename]="bulkImportResult.failedRowsFilename">
    </app-bulk-import-result>
   
    <div class="container-table">
      <header class="top-header">
        <h3>BlackListed Vehicles</h3>
        <p>Vehicle Details As On {{todayDate | date: "dd-MM-yyyy" }}</p>
      </header>
      <!-- <div class="card-top card-head">
        <h4>BlackListed Vehicles</h4>
        <p>Vehicle Details As On 20-10-2024</p>
      </div> -->
      <div>
        <div class="tab-head">
          <div class="search-bar">
            <div>
              <!-- <form  (ngSubmit)="vehicleSearch()">
                <input type="text" [(ngModel)]="searchText" name='searchText' id="searchText" placeholder="Search">
                <button type="submit" style="width: 40px; height: 40px; border-radius: 50%; border: none; background: rgb(37, 139, 229); cursor: pointer;" hidden>
                  <fa-icon [icon]="['fas', 'magnifying-glass']" class="fa-thin" style="color: rgb(228, 235, 237);font-size: 20px;"></fa-icon>
                </button>
              </form> -->
              <app-generic-search
                [apiUrl]="'blacklisted-vehicles/search_suggestion'"
                [resultsApiUrl]="'blacklisted-vehicles/'"
                [method]="'GET'"
                [searchParamName]="'q'"
                [pageSize]="10"
                [minChars]="2"
                (resultsFetched)="onResults($event)">
              </app-generic-search>
            </div>
          </div>
          <button (click)="exportToExcel()" class="export-button">
            <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
            EXPORT EXCEL
          </button>
        </div>
        <div class="responsive-table-wrapper">
          <table>
            <thead>
                <tr>
                <th>S.No</th>
                <th>Vehicle No</th>
                    <th>Person Name</th>
                <th>Reason</th>
                <th>Created By</th>
                <th>Created On</th>
                <th>Action Item</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let record of blackedVehicle let i = index ">
                  <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
                    <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                    <td>{{ record.person_name || '-' }}</td>
                  <td>
                    <div class="content-tooltip-container">
                      <div class="text-clip" (mouseenter)="hoverRowId=record.id" (mouseleave)="hoverRowId=null">
                          {{ record.reason }}
                        </div>
                        <div 
                              class="content-tooltip" *ngIf="hoverRowId === record.id && record.reason.length > 30"
                            >
                            {{ record.reason }}
                      </div>
                    </div>
                  </td>
                  <td>{{ record.created_by}}</td>
                  <td>{{ record.created_at | date: 'dd-MM-yyyy hh:mm a' }}</td>
                  <td>
                    <button class="unblack-button" (click)="openConfirmationDialog(record.id)" [disabled]="role === 'Member'" [title]="role === 'Member' ? 'You are not authorized to perform this action.': 'Whitelist'">
                      <!-- <fa-icon [icon]="['fas', 'car']"></fa-icon> -->
                       <!-- <img class="img-unblack" src="vehicle-images/checked-car-svgrepo-com.svg" alt="Image-logo"> -->
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2ecc71" stroke-width="2">
                        <!-- Circle Outline -->
                        <circle cx="12" cy="12" r="10" stroke-linecap="round"/>
                        <!-- Rounded Tick -->
                        <path d="M8 12.5l2.5 2.5L16 9" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>

                       Whitelist
                    </button>
                  </td>
                </tr>
            </tbody>
          </table>
        
          <div class="footer">
            <div class="total-records">Total Records: {{ totalRecords }}</div>
            <div class="pagination-controls">
              <label for="recordsPerPage">Records per page </label>
              <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()" >
                  <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
              </select>
              <span>{{ currentPage }} / {{ totalPages }}</span>
              <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
                <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
              </button>
              <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
                <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Confirmation dialog for Unblack vehicle-->
  <!-- <div *ngIf="showConfirmationDialog" class="modal">
    <div class="modal-content">
      <h3>Are you sure you want to unblack permanently?</h3>
      <div class="options">
        <button type="button" class="btn-cancel" (click)="closeConfirmationDialog()">CANCEL</button>
        <button type="submit" class="btn-confirm" (click)="confirmUnblack()">Confirm</button>
        
      </div>
    </div>
  </div> -->

  <div *ngIf="showConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
      <div class="modal-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" stroke="green" stroke-width="1" fill="none"/>
        <path d="M9 12l2 2 4-4" stroke="green" stroke-width="1"/>
        </svg>
        <h3>Are You Sure?</h3>
      </div>
      <div class="modal-body">
        <p>Do you want to remove vehicle from blacklist? Confirm your choice below!</p>
      </div>
      <div class="modal-footer">
        <button (click)="confirmUnblack()" class="confirm-btn modal-green">Yes, Proceed</button>
        <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-red">Cancel</button>
      </div>
  </div>
  </div>

  <!-- Modal for showing reason -->
  <!-- <div *ngIf="showReason" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeReason()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="popup-content">
        <div class="popup-item">
          <div>
            <p>{{reason}}</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->


  <!-- Responsive  -->
  <!-- <div class="d-flex align-items-center h-100">
    <div class="container-fluid h-100">
      <div class="d-flex justify-content-center align-items-center h-100 ">
    <div class="card w-100">
      <div class="card-body">
        <div class="card-top">
          <h4>Black Listed Vehicle</h4>
          <p>Vehicle Details</p>
        </div>
        <div class="row pb-4">
          <div class="col-12 col-md-6">
            <div class="search-bar">
                <form  (ngSubmit)="vehicleSearch()">
                  <input type="text" [(ngModel)]="searchText" name='searchText' id="searchText" placeholder="Search">
                  <button type="submit" style="width: 40px; height: 40px; border-radius: 50%; border: none; background: rgb(37, 139, 229); cursor: pointer;" hidden>
                    <fa-icon [icon]="['fas', 'magnifying-glass']" class="fa-thin" style="color: rgb(228, 235, 237);font-size: 20px;"></fa-icon>
                  </button>
                </form>
            </div>
          </div>
          <div class="col-12 col-md-6 text-md-end">
            <button (click)="exportToExcel()" class="export-button">
              <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
              EXPORT EXCEL
            </button>
          </div>
        </div>
        <div class="row"></div>
        <div class="table-responsive">
          <table class="table">
            <thead class="table-primary">
              <tr>
                <th>S.No</th>
                <th>Vehicle No</th>
                <th>Reason</th>
                <th>Created On</th>
                <th>Action Item</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of blackedVehicle let i = index ">
                <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> 
                <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                <td>{{ record.reason }}</td>
                <td>{{ record.created_at | date: 'dd-MM-yyyy hh:mm a' }}</td>
                <td>
                  <button class="unblack" (click)="openConfirmationDialog(record.id)">
                    Unblack
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  </div>
  </div> -->